module.exports = __webpack_public_path__ + "img/mon_64.7113395f.png";